// src/pages/PatientsOverview/PatientsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInsuranceList,
  fetchPatientList,
  createOrUpdateInsurance,
  createOrUpdatePatient,
  removeInsurance,
  removePatient,
  fetchInsuranceCompaniesLookup,
} from "./PatientsThunk";

const initialState = {
  insuranceList: [],
  patientList: [],
  insuranceLookup: [],

  // modal & edit state
  selectedInsurance: null,
  selectedPatient: null,
  isInsuranceModalOpen: false,
  isPatientModalOpen: false,
  isEditInsurance: false,
  isEditPatient: false,

  loading: false,
  error: null,
};

const patientsSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    openInsuranceModal: (state, action) => {
      state.isInsuranceModalOpen = true;
      state.selectedInsurance = action.payload || null;
      state.isEditInsurance = !!action.payload;
    },
    closeInsuranceModal: (state) => {
      state.isInsuranceModalOpen = false;
      state.selectedInsurance = null;
      state.isEditInsurance = false;
    },
    openPatientModal: (state, action) => {
      state.isPatientModalOpen = true;
      state.selectedPatient = action.payload || null;
      state.isEditPatient = !!action.payload;
    },
    closePatientModal: (state) => {
      state.isPatientModalOpen = false;
      state.selectedPatient = null;
      state.isEditPatient = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch insurance list
      .addCase(fetchInsuranceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInsuranceList.fulfilled, (state, action) => {
        state.loading = false;
        state.insuranceList = action.payload.data || action.payload || [];
      })
      .addCase(fetchInsuranceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetch patients
      .addCase(fetchPatientList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPatientList.fulfilled, (state, action) => {
        state.loading = false;
        state.patientList = action.payload.data || action.payload || [];
      })
      .addCase(fetchPatientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create/update insurance
      .addCase(createOrUpdateInsurance.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrUpdateInsurance.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createOrUpdateInsurance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create/update patient
      .addCase(createOrUpdatePatient.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrUpdatePatient.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createOrUpdatePatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // remove insurance
      .addCase(removeInsurance.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeInsurance.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removeInsurance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // remove patient
      .addCase(removePatient.pending, (state) => {
        state.loading = true;
      })
      .addCase(removePatient.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(removePatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // lookup
      .addCase(fetchInsuranceCompaniesLookup.fulfilled, (state, action) => {
        state.insuranceLookup = action.payload || [];
      });
  },
});

export const {
  openInsuranceModal,
  closeInsuranceModal,
  openPatientModal,
  closePatientModal,
} = patientsSlice.actions;

export default patientsSlice.reducer;
